export default {
    title: 'Innovation field'
}
